export const ENTER_KEY = 'Enter';
export const SPACE_KEY = ' ';
export const TAB_KEY = 'Tab';
export const ESCAPE_KEY = 'Escape';
export const BACKSPACE_KEY = 'Backspace';
export const DOWN_ARROW_KEY = 'ArrowDown';
export const UP_ARROW_KEY = 'ArrowUp';
